import script from "./DhOptionalElement.vue?vue&type=script&lang=ts"
export * from "./DhOptionalElement.vue?vue&type=script&lang=ts"

export default script